import { render, staticRenderFns } from "./authentication.vue?vue&type=template&id=2fdcce88&scoped=true&"
import script from "./authentication.vue?vue&type=script&lang=js&"
export * from "./authentication.vue?vue&type=script&lang=js&"
import style0 from "./authentication.vue?vue&type=style&index=0&id=2fdcce88&prod&lang=less&scoped=true&"
import style1 from "./authentication.vue?vue&type=style&index=1&id=2fdcce88&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdcce88",
  null
  
)

export default component.exports